import IUser from '@/types/IUser';
import React from 'react';

interface IImpersonatedUserContext {
	impersonatedUser?: IUser;
	setImpersonatedUser: (user: IUser | undefined) => void;
}

export default React.createContext<IImpersonatedUserContext | undefined>(undefined);
